export class Config {
  // Define Global Variable
  // static apiPath2 = "https://192.168.70.103:45455";
  static imagePath2 = "https://api.erviniqos.com";
  static skeletonHighlightColor2 = "#89fdff";
  static helmetTitle2 = "اروین آیکوس";
  static beforeColor2 = "#00cacd";
  static footerAddress2 = "https://erviniqos.com";
  static footerCompany2 = "اروین آیکوس";
  // -2
  // static apiPath = "https://kar30api.idetest.ir";
  // static imagePath = "https://kar30admin.idetest.ir";
  // static apiPath2 = "https://panel.sadrayar.ir";
  // static apiPath = "http://192.168.70.103:45455";
  static apiPath2 = "https://kar30api.idetest.ir";
  static apiPath = "https://api.sadrayar.ir";
  static imagePath = "https://admin.sadrayar.ir";
  static skeletonHighlightColor = "#909ee1";
  static helmetTitle = "صدرا یار";
  static beforeColor = "#1F3BCD";
  static footerAddress = "https://tecomid.com";
  static footerCompany = "ایده پرداز تجارت الکترونیک طوبی";

  static redirectUrl = "https://panel.sadrayar.ir";

  static separate = (Number) => {
    Number += "";
    // Number = Number.replace(',', '');
    Number = Number.replace(/\,/g, "");
    let x = Number.split(".");
    let y = x[0];
    let z = x.length > 1 ? "." + x[1] : "";
    let rgx = /(\d+)(\d{3})/;
    while (rgx.test(y)) y = y.replace(rgx, "$1" + "," + "$2");
    return y + z;
  };

  static convertToBase64 = async (blob) => {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

  static pageUp = () => {
    if (typeof window !== "undefined" && window.pageYOffset > 0) {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 100);
    }
    return false;
  };

  static checkMobileValidate = (mobile) => {
    // const mobilePattern = /^(\+989|9|09)(12|19|35|36|37|38|39|32|30|28|22|21|20|03)\d{7}$/;
    const mobilePattern = /^(\+989|9|09)\d{9}$/;
    if (!mobile.match(mobilePattern)) {
      return false;
    } else {
      return true;
    }
  };

  static getCookie = (cookieName) => {
    let name = cookieName + "=";
    let decodedCookie = decodeURIComponent(typeof document !== "undefined" ? document.cookie : null);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  };
}
